/**
 * Extracts unique filter options from document data for React Select dropdowns
 */
export function deriveFilterOptions(documents) {
    const categories = new Set();
    const sites = new Set();
    const clients = new Set();

    documents.forEach((doc) => {
        if (doc.category) categories.add(doc.category);
        if (doc.siteName) sites.add(doc.siteName);
        if (doc.clientName) clients.add(doc.clientName);
    });

    const toOptions = (set) =>
        [...set].sort().map((v) => ({ value: v, label: v }));

    return {
        categories: toOptions(categories),
        sites: toOptions(sites),
        clients: toOptions(clients),
    };
}

/**
 * Formats an ISO date string to DD/MM/YYYY
 */
export function formatDate(isoStr) {
    if (!isoStr) return '';
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}

/**
 * Extracts the file extension from a URL or filename
 */
export function getFileExtension(url) {
    if (!url) return '';
    const cleaned = url.split('?')[0];
    const dot = cleaned.lastIndexOf('.');
    if (dot === -1) return '';
    return cleaned.substring(dot + 1).toLowerCase();
}
